import styled from 'styled-components';
import getColour from '@lendi-ui/commons/colours';
import { pr, px } from '@lendi-ui/spacing';
import { body } from '@lendi-ui/typography';

export const Container = styled.div<{ isVisible: boolean }>`
  ${({ isVisible }) => !isVisible && 'display: none'};
`;

export const ToolContainer = styled.div`
  display: flex;
  justify-content: space-between;
  ${px('sm')}
`;

export const ToolWrapper = styled.div`
  display: flex;
`;

export const CheckBoxWrapper = styled.div`
  display: flex;
  ${pr('sm')}
  label {
    width: auto;
    ${pr('sm')}
  }
`;

export const Warning = styled.div`
  align-self: center;
  ${body({ size: 'xs', color: 'warn.500' })}
`;

export const ToolSticker = styled.div`
  position: absolute;
  float: right;
  right: 1rem;
  top: 0;
  z-index: 200;
  border-radius: 0 0 3px 3px;
  cursor: pointer;
  background-color: ${() => getColour('interaction', 'main')};
  color: ${() => getColour('interaction', 'subtle')};
  ${body({ size: 'xs' })}
  ${px('xs')}
`;

export const MockDataWrapper = styled.div`
  ${px('sm')}
`;
